import React, { useEffect, useContext } from 'react';

import UiContext from 'common/UiContext/UiContext';
import useApi from 'common/useApi';

import DashboardWorkerSummary from 'components/DashboardWorkerSummary';
import Loading from 'components/Loading';

import WorkerAlertBanner from 'components/WorkerAlertBanner';
import WorkersTable from 'components/WorkersTable';

const Workers = () => {
  const { addToast } = useContext(UiContext);
  const { data, isError, isLoading } = useApi('get', '/api/dashboard/totals');

  useEffect(() => {
    if(isError) {
        addToast!('Error loading data. Please, retry');
    }
  }, [isError]);

  if(isLoading) {
    return <Loading />;
  }

  return (
    <>
      <WorkerAlertBanner count={data?.workers_low} />
      <DashboardWorkerSummary isLoading={isLoading} data={data} />
      <WorkersTable />
    </>
  );
};

export default Workers;